import styled from 'styled-components';
import media from "styled-query"

export const Container = styled.div`
  width: 300px;
  height: 300px;
  background: transparent;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;

  ${media.lessThan("1023px")`
    margin-top: 25px;
  `}
`;

export const Content = styled.div`
  width: 241px;
  height: 241px;
  background: var(--white);
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;  
`;

export const Text = styled.h2`
  margin-top: 10px;
`;